/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-11-21 21:08:21
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../../utils/Utils';

import BsyTextEditor from '../../BsyTextEditor';
import BsyFilterBase from '../BsyFilterBase';

import './index.css'
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterTextArea extends BsyFilterBase {
    constructor(props) {
        super({
            minRow: 10,
            onStopEdit: null,
            ...props
        })

        this.dashText = null;
    }

    _getAvailableMethods = () => {
        return [BsyConfig().CONST.FILTER_METHOD.LK,
        BsyConfig().CONST.FILTER_METHOD.ULK,
        BsyConfig().CONST.FILTER_METHOD.EP,
        BsyConfig().CONST.FILTER_METHOD.NEP]
    }

    getValue = () => {

        if (this.dashText) {
            let e = this.dashText.getValue()

            switch (this.method) {
                case BsyConfig().CONST.FILTER_METHOD.LK:
                case BsyConfig().CONST.FILTER_METHOD.ULK:
                    return {
                        value: e
                    };
                default:
                    return null
            }

        }
        return null
    }

    getContext = (e) => {
        this.dashText = e;
    }

    renderCont = () => {
        let e = this
        let i = this.options;

        let val = this.getMiddleValue();


        switch (e.method) {
            case BsyConfig().CONST.FILTER_METHOD.LK:
            case BsyConfig().CONST.FILTER_METHOD.ULK:

                return <BsyTextEditor
                    getContext={this.getContext}
                    width={"100%"}
                    height={'34px'}
                    value={val ? val.value : null}
                    onStopEdit={(t) => {
                        e.value = e.getValue()
                        BsyUtils.applyFunc(this, this.props.onStopEdit, [{
                            value: e.getValue(),
                            method: e.method,
                            valueMode: e.valueMode
                        }, i], !1)
                    }}
                ></BsyTextEditor>

            default:
                break;
        }
    }
    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }

}

